var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m957.1 865.6-58.453-96.094v0.046875c-32.344-53.016-101.53-69.844-154.55-37.5l-48.281 29.391c-14.297 8.9062-32.812 6.9844-45-4.6406-77.297-76.078-134.48-170.16-166.5-273.74-4.5469-16.172 2.2969-33.375 16.734-42l48.281-29.344-0.046875-0.046875c53.062-32.344 69.844-101.53 37.5-154.55l-58.5-96.094c-32.344-53.016-101.53-69.797-154.55-37.5l-93.234 56.484c-33.562 20.156-54.094 56.438-54.047 95.578-0.046875 166.31 45.562 329.44 131.81 471.61 86.672 141.05 209.86 256.03 356.53 332.81 16.453 8.625 34.781 13.172 53.391 13.219 20.531 0 40.688-5.6719 58.219-16.359l93.141-56.719c53.016-32.344 69.797-101.53 37.5-154.55z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonew);
export default __webpack_public_path__ + "static/media/phonew.53a40bc552fb0bc162e0d00966e83cea.svg";
export { ForwardRef as ReactComponent };